var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgEdit16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29287 14.9498L15.071 5.17158L10.8284 0.92894L1.05023 10.7071V14.9498L5.29287 14.9498ZM10.8284 3.75737L12.2426 5.17158L10.9142 6.5L9.49998 5.08579L10.8284 3.75737ZM8.08577 6.5L3.05023 11.5355L3.05023 12.9498L4.46445 12.9498L9.49998 7.91422L8.08577 6.5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;